import React from 'react'
import 'react-quill-new/dist/quill.snow.css'
import './quill-renderer.scss'

const QuillRenderer = ({ htmlContent, style = {} }) => {
    return (
        <div className='quill-renderer ql-container'>
            <div className='ql-snow'>
                <div className='ql-editor' style={{ ...style }} dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </div>
        </div>
    )
}

export default QuillRenderer
